








































































































































































































































































































































































import {
  Vue,
  Component,
  Prop,
  Provide,
  Emit,
  Watch,
  Inject,
} from "vue-property-decorator";
import { Http,Util } from "@/utils";
import NavDataService from "@/api/service/app/navdata-service";
import { Subject, Subscription } from "rxjs";
import { Environment } from "@/environments/environment";
import { postMessageToIframe, getSysUrl } from "@/utils/menu-path/menu-path";
import HomePage from "../home-page/index.vue";
import HomePageSecond from "../home-page/indexSecond.vue";
import { appConfig } from "@/config/appConfig";
import AppCenterService from "@service/app/app-center-service";
import PhoneChangePassword from './service-phone-changepw.vue'
import HomePageService from '../home-page/HomePageService';
import axios from 'axios';
// @ts-ignore
import md5 from 'md5'
@Component({
  components: { HomePage, HomePageSecond,PhoneChangePassword },
})
export default class AppIndexViewBase extends Vue {
  public loginServiceCallVisible:boolean=false//服务商软电话登录
  public bohaopanVisible:boolean=false//拨号盘弹窗
  public intelligentAssistanceShow:boolean=false//拨号盘弹窗
  public serviceName:string=''
   public title : string = '';

  public content: string = '';
  public fileupload: string = '';
  public data: any = {};
  public visible: any = false;
  public readNotice (val:any){
    // alert(val)
     //@ts-ignore
    const user:any=JSON.parse(localStorage.getItem('user'))
      HomePageService.getNoticeDetail(val.mpnoticeid).then(res => {
let _this = this
      if(res && res.data) {
        try {
          this.$http.post(`/cssmobileplatformapi/appapi/noticeRead`,{
            mpNoticeId:res.data.mpnoticeid,
            userCode:user.userCode
            //@ts-ignore
            }).then((res) => {
               this.$nextTick(() => {
                 setTimeout(() => {
              // _this.getNotice({page:0,size: 9999,sort: 'create_date,desc',n_client_type_eq:'pc'});
                this.noticeList.forEach((item:any,index:any) => {
                if (val.mpnoticeid ==  this.noticeList[index].mpnoticeid) {
                    this.noticeList.splice(index,1)
                  // alert(1)
                }
              })

              },100)
                //@ts-ignore
              this.$bus.$emit('isread',true)
             })
            })
             this.visible = true
              let data = res.data;
              this.data = res.data
              this.title = data.noticename;
              this.content = data.noticecontent;
        } catch (error) {
        }

      }
    })

  }
    public noticeList:any=[]
      /**
   * Vue声明周期(组件初始化完毕)
   *
   * @memberof AppIndexViewBase
   */
  public mounted() {
    this.isHotLineSpec();
    this.afterMounted();
    this.handleMessage();
    this.tokenPost(this.$route.fullPath);
    let _this = this
    setTimeout(() => {
      _this.getNotice({page:0,size: 10,n_client_type_eq:'pc',n_is_read_eq:'0'});
    },1000)
  }

   /**
     * 公告通知
     */
    public getNotice(param : Object) {
      this.noticeList = [];
      HomePageService.getNotice(param).then(res => {
        if (res.data && res.data.length > 0) {
          res.data.forEach((item:any) => {
            if (item.isMustRead == '1' && item.isRead == '0') {
                this.noticeList.push(item);
              // alert(1)
            }
          })
          console.log('this.noticeList',this.noticeList)
        }
      })
    }
  public zuoxiForm = {
    userName: "",
    password: "",
    phoneTp:'1'
  }
  public zuoxiFormRule = {
    userName: [
      {required: true, message: '账号不允许为空', trigger: 'blur'}
    ],
    password: [
      {required: true, message: '密码不允许为空', trigger: 'blur'}
    ],
  }
  public bohao(val:any){
    const iframe: any = this.$refs.serviceCallIframe
    iframe.contentWindow.postMessage({type:'cssToServiceCall',cssworkData:{type:'bohao',num:val}}, '*')
  }
  public asyncOK(){
    // @ts-ignore
    this.$refs.zuoxiForm.validate((valid: boolean) => {
      if(!valid) return
      this.serviceName=this.zuoxiForm.userName
      const iframe: any = this.$refs.serviceCallIframe
      let companyId='541'
      if(location.origin=='https://css.jomoo.cn' || location.origin=='https://css.jomoo.com'){
        companyId='508'
      }else{
        companyId='541'
      }
      iframe.contentWindow.postMessage({type:'cssToServiceCall',cssworkData:{...this.zuoxiForm,type:'loginServicePhone',companyId}}, '*');
      this.loginServiceCallVisible=false
      this.$http.get(`/cssworkorderapi/woclientcontact/saveMappingRelationships?rlccCode=${this.serviceName}`).catch(()=>console.error('呼入接口发送账号失败'))
    })
  }
  public iframeUrl: any = null;
  public woIframeUrl: any = (Environment as any).WkdUrl;
  public bdIframeUrl: any = (Environment as any).BasicDataUrl;
  public spIframeUrl: any = (Environment as any).SparePartsUrl;
  public rtIframeUrl: any = (Environment as any).RuntimeUrl;
  public reIframeUrl: any = (Environment as any).ReportUrl;
  // public value: string = '0' // 下拉框选择值
  public iframeVisible: boolean = false; // 智能辅助弹框重载
  public centerDialogVisible: boolean = false; // 智能辅助弹框是否展开
  public centerDialogShowStatus: boolean = false; // 智能辅助弹框正常/缩小显示

  showArr: any = new Array(5).fill(false);
  refArr: any = ["bdIframe", "woIframe", "spIframe", "rtIframe","reIframe"]; // iframe的ref值
  urlPrefix: any = ["cssbd", "csswkd", "csssp", "/index",'cssre']; // 各个子系统的url的prefix

  portalRoute: any = [
    "notice-table",
    "message-table",
    "startedTask",
    "complatedTask",
    "todoTask",
    "monitor",
  ]; // portal的路由

  public isFromSubSystem: boolean = false;
  isRefresh: boolean = false;
  public timer: any = null;
  menuclick($event: any) {
    this.toggleIframe($event);
  }

  get portalMenu() {
    const issubSys: any = this.urlPrefix.some((item: any) =>
      this.$route.fullPath.includes(item)
    );
    return !issubSys && this.$store.state.pageMetas.length > 0;
  }
  /**
   * 数据变化
   *
   * @param {*} val
   * @returns {*}
   * @memberof AppIndexViewBase
   */
  @Emit()
  public viewDatasChange(val: any): any {
    return val;
  }

  /**
   * 传入视图上下文
   *
   * @type {string}
   * @memberof AppIndexViewBase
   */
  @Prop() public viewdata!: string;

  /**
   * 传入视图参数
   *
   * @type {string}
   * @memberof AppIndexViewBase
   */
  @Prop() public viewparam!: string;

  /**
   * 视图默认使用
   *
   * @type {boolean}
   * @memberof AppIndexViewBase
   */
  @Prop({ default: true }) public viewDefaultUsage!: boolean;

  /**
   * 视图标识
   *
   * @type {string}
   * @memberof AppIndexViewBase
   */
  public viewtag: string = "2530708d453013b497aebeb7a0a9cd7c";

  /**
   * 自定义视图导航上下文集合
   *
   * @type {*}
   * @memberof AppIndexViewBase
   */
  public customViewNavContexts: any = {};

  /**
   * 自定义视图导航参数集合
   *
   * @type {*}
   * @memberof AppIndexViewBase
   */
  public customViewParams: any = {};

  /**
   * 视图模型数据
   *
   * @type {*}
   * @memberof AppIndexViewBase
   */
  public model: any = {
    srfCaption: "app.views.appindexview.caption",
    srfTitle: "app.views.appindexview.title",
    srfSubTitle: "app.views.appindexview.subtitle",
    dataInfo: "",
  };

  /**
   * 视图参数变化
   *
   * @param {*} newVal
   * @param {*} oldVal
   * @memberof AppIndexViewBase
   */
  @Watch("viewparam", { immediate: true, deep: true })
  onParamData(newVal: any, oldVal: any) {
    if (newVal) {
      this.viewparams = {};
      if (typeof newVal == "string") {
        Object.assign(this.viewparams, JSON.parse(this.viewparam));
      } else {
        this.viewparams = Util.deepCopy(this.viewparam);
      }
    }
  }

  /**
   * 处理应用上下文变化
   *
   * @param {*} newVal
   * @param {*} oldVal
   * @memberof AppIndexViewBase
   */
  @Watch("viewdata")
  onViewData(newVal: any, oldVal: any) {
    const _this: any = this;

    if (!Object.is(newVal, oldVal) && _this.engine) {
      this.$nextTick(() => {
        _this.parseViewParam();
        _this.engine.load();
      });
    } else if (
      !Object.is(newVal, oldVal) &&
      _this.refresh &&
      _this.refresh instanceof Function
    ) {
      _this.refresh();
    }
  }

  /**
   * 容器模型
   *
   * @type {*}
   * @memberof AppIndexViewBase
   */
  public containerModel: any = {
    view_appmenu: { name: "appmenu", type: "APPMENU" },
  };

  /**
   *  计数器刷新
   *
   * @memberof AppIndexViewBase
   */
  public counterRefresh() {
    const _this: any = this;
    if (_this.counterServiceArray && _this.counterServiceArray.length > 0) {
      _this.counterServiceArray.forEach((item: any) => {
        if (item.refreshData && item.refreshData instanceof Function) {
          item.refreshData();
        }
      });
    }
  }

  /**
   * 视图状态订阅对象
   *
   * @public
   * @type {Subject<{action: string, data: any}>}
   * @memberof AppIndexViewBase
   */
  public viewState: Subject<ViewState> = new Subject();

  /**
   * 引擎初始化
   *
   * @public
   * @memberof AppIndexViewBase
   */
  public engineInit(): void {}

  /**
   * 应用导航服务
   *
   * @type {*}
   * @memberof AppIndexViewBase
   */
  public navDataService = NavDataService.getInstance();

  /**
   * 导航服务事件
   *
   * @public
   * @type {(Subscription | undefined)}
   * @memberof AppIndexViewBase
   */
  public serviceStateEvent: Subscription | undefined;

  /**
   * 门户部件状态对象
   *
   * @type {*}
   * @memberof AppIndexViewBase
   */
  @Prop() public portletState?: any;

  /**
   * 门户部件状态事件
   *
   * @public
   * @type {(Subscription | undefined)}
   * @memberof AppIndexViewBase
   */
  public portletStateEvent: Subscription | undefined;

  /**
   * 应用上下文
   *
   * @type {*}
   * @memberof AppIndexViewBase
   */
  public context: any = {};

  /**
   * 视图参数
   *
   * @type {*}
   * @memberof AppIndexViewBase
   */
  public viewparams: any = {};

  /**
   * 视图缓存数据
   *
   * @type {*}
   * @memberof AppIndexViewBase
   */
  public viewCacheData: any;
  public activePath: string = "";

  /**
   * 计数器服务对象集合
   *
   * @type {Array<*>}
   * @memberof AppIndexViewBase
   */

  public counterServiceArray: Array<any> = [];

  /**
   * 解析视图参数
   *
   * @public
   * @memberof AppIndexViewBase
   */
  public parseViewParam(inputvalue: any = null): void {
    for (let key in this.context) {
      delete this.context[key];
    }
    if (
      this.$store.getters.getAppData() &&
      this.$store.getters.getAppData().context
    ) {
      Object.assign(this.context, this.$store.getters.getAppData().context);
    }
    if (
      !this.viewDefaultUsage &&
      this.viewdata &&
      !Object.is(this.viewdata, "")
    ) {
      if (typeof this.viewdata == "string") {
        Object.assign(this.context, JSON.parse(this.viewdata));
      }
      if (this.context && this.context.srfparentdename) {
        Object.assign(this.viewparams, {
          srfparentdename: this.context.srfparentdename,
        });
      }
      if (this.context && this.context.srfparentkey) {
        Object.assign(this.viewparams, {
          srfparentkey: this.context.srfparentkey,
        });
      }
      this.handleCustomViewData();
      return;
    }
    const path = this.$route.matched[this.$route.matched.length - 1].path;
    const keys: Array<any> = [];
    const curReg = this.$pathToRegExp.pathToRegexp(path, keys);
    const matchArray = curReg.exec(this.$route.path);
    let tempValue: Object = {};
    keys.forEach((item: any, index: number) => {
      if (matchArray[index + 1]) {
        Object.defineProperty(tempValue, item.name, {
          enumerable: true,
          value: decodeURIComponent(matchArray[index + 1]),
        });
      }
    });
    this.$viewTool.formatRouteParams(
      tempValue,
      this.$route,
      this.context,
      this.viewparams
    );
    this.handleCustomViewData();
    //初始化导航数据
    this.initNavDataWithRoute();
  }

  /**
   * 处理自定义视图数据
   *
   * @memberof AppIndexViewBase
   */
  public handleCustomViewData() {
    if (Object.keys(this.customViewNavContexts).length > 0) {
      Object.keys(this.customViewNavContexts).forEach((item: any) => {
        let tempContext: any = {};
        let curNavContext: any = this.customViewNavContexts[item];
        this.handleCustomDataLogic(curNavContext, tempContext, item);
        Object.assign(this.context, tempContext);
      });
    }
    if (Object.keys(this.customViewParams).length > 0) {
      Object.keys(this.customViewParams).forEach((item: any) => {
        let tempParam: any = {};
        let curNavParam: any = this.customViewParams[item];
        this.handleCustomDataLogic(curNavParam, tempParam, item);
        Object.assign(this.viewparams, tempParam);
      });
    }
  }

  /**
   * 处理自定义视图数据逻辑
   *
   * @memberof AppIndexViewBase
   */
  public handleCustomDataLogic(curNavData: any, tempData: any, item: string) {
    // 直接值直接赋值
    if (curNavData.isRawValue) {
      if (
        Object.is(curNavData.value, "null") ||
        Object.is(curNavData.value, "")
      ) {
        Object.defineProperty(tempData, item.toLowerCase(), {
          value: null,
          writable: true,
          enumerable: true,
          configurable: true,
        });
      } else {
        Object.defineProperty(tempData, item.toLowerCase(), {
          value: curNavData.value,
          writable: true,
          enumerable: true,
          configurable: true,
        });
      }
    } else {
      // 先从导航上下文取数，没有再从导航参数（URL）取数，如果导航上下文和导航参数都没有则为null
      if (this.context[curNavData.value.toLowerCase()] != null) {
        Object.defineProperty(tempData, item.toLowerCase(), {
          value: this.context[curNavData.value.toLowerCase()],
          writable: true,
          enumerable: true,
          configurable: true,
        });
      } else {
        if (this.viewparams[curNavData.value.toLowerCase()] != null) {
          Object.defineProperty(tempData, item.toLowerCase(), {
            value: this.viewparams[curNavData.value.toLowerCase()],
            writable: true,
            enumerable: true,
            configurable: true,
          });
        } else {
          Object.defineProperty(tempData, item.toLowerCase(), {
            value: null,
            writable: true,
            enumerable: true,
            configurable: true,
          });
        }
      }
    }
  }

  /**
   * 初始化导航数据(路由模式)
   *
   * @memberof AppIndexViewBase
   */
  public initNavDataWithRoute(
    data: any = null,
    isNew: boolean = false,
    isAlways: boolean = false
  ) {
    if (
      isAlways ||
      (this.viewDefaultUsage && Object.is(this.navModel, "route"))
    ) {
      this.navDataService.addNavData({
        id: "app-index-view",
        tag: this.viewtag,
        srfkey: isNew ? null : null,
        title: this.$t(this.model.srfCaption),
        data: data,
        context: this.context,
        viewparams: this.viewparams,
        path: this.$route.fullPath,
      });
    }
  }

  /**
   * 初始化导航数据(分页模式)
   *
   * @memberof AppIndexViewBase
   */
  public initNavDataWithTab(
    data: any = null,
    isOnlyAdd: boolean = true,
    isAlways: boolean = false
  ) {
    if (
      isAlways ||
      (this.viewDefaultUsage && !Object.is(this.navModel, "route"))
    ) {
      this.navDataService.addNavDataByOnly(
        {
          id: "app-index-view",
          tag: this.viewtag,
          srfkey: null,
          title: this.$t(this.model.srfCaption),
          data: data,
          context: this.context,
          viewparams: this.viewparams,
          path: this.$route.fullPath,
        },
        isOnlyAdd
      );
    }
  }

  public agentId: any = "";
  public agentExt: any = "";
  public serviceCallHtml:any='https://csstest.jomoo.cn/softphonebar/index.html'
  public isService:boolean=false
  public created() {

    //  @ts-ignore
    const userInfo=JSON.parse(localStorage.getItem('user'))
    let baseUrl='https://csstest.jomoo.cn/softphonebar/index.html'
    if(location.origin.includes('http://localhost')){
      baseUrl='http://localhost:9999/ccsdk/index.html'
    }else{
      baseUrl=location.origin+'/softphonebar/index.html'
    }
    this.serviceCallHtml=baseUrl+`?loginCode=${userInfo.userCode}&loginName=${userInfo.personName}`
    //  @ts-ignore
    let authorities=JSON.parse(localStorage.getItem('user')).permissionList.authorities.includes('UNIRES_cssworkorder-BT_SOFT_PHONE_BAR')
    if(authorities){
      this.$http.get(`/cssworkorderapi/wosmvisittasks/checkstarLevelbyloginperson`,true).then((res:any)=>{
        this.isService=res.data
        if(this.isService) this.loginServiceCallVisible=true
      })
    }
    //@ts-ignore
    this.intelligentAssistanceShow=JSON.parse(localStorage.getItem('user')).permissionList.authorities.includes('UNIRES_cssworkorder-BT_PO_INTELLIGENTASSISTANCE')
    //  @ts-ignore
    this.$bus.$on("phoneInfo", (e: any) => {
      this.agentId = e.agentId;
      this.agentExt = e.agentExt;
      this.callHtml = `https://softphone.jomoo.cn/SoftPhonePortal/softPhone?agentId=${this.agentId}&ext=${this.agentExt}`;
      let callFrame: any = document.getElementById("callIframe");
      if (callFrame) {
        callFrame.src = this.callHtml;
      }
      if (e.agentId && e.agentExt) {
        // @ts-ignore
        this.$softPhone.jsGetServersInfo(
          this.agentId,
          this.agentExt,
          this,
          this.$refs.iframe
        );
      }
    });


    this.afterCreated();
  }

  // TODO:获取坐席账号
  // agentId: any = '7996'
  // agentExt: any = '7998'
  public callHtml: any = `https://softphone.jomoo.cn/SoftPhonePortal/softPhone?agentId=${this.agentId}&ext=${this.agentExt}`;

  /**
   * 执行created后的逻辑
   *
   * @memberof AppIndexViewBase
   */

  public afterCreated() {
    let _this: any = this;
    const secondtag = _this.$util.createUUID();
    _this.$store.commit("viewaction/createdView", {
      viewtag: _this.viewtag,
      secondtag: secondtag,
    });
    _this.viewtag = secondtag;
    _this.parseViewParam();
    _this.serviceStateEvent = _this.navDataService.serviceState.subscribe(
      ({ action, name, data }: { action: string; name: any; data: any }) => {
        if (!Object.is(name, "app-index-view")) {
          return;
        }
        if (Object.is(action, "viewrefresh")) {
          _this.$nextTick(() => {
            _this.parseViewParam(data);
            if (_this.engine) {
              _this.engine.load();
            }
          });
        }
      }
    );
    if (_this.portletState) {
      _this.portletStateEvent = _this.portletState.subscribe((res: any) => {
        if (!Object.is(res.name, "AppIndexView")) {
          return;
        }
        if (
          Object.is(res.action, "refresh") &&
          _this.refresh &&
          _this.refresh instanceof Function
        ) {
          _this.refresh();
        }
      });
    }
  }

  /**
   * 销毁之前
   *
   * @memberof AppIndexViewBase
   */
  public beforeDestroy() {
    this.$store.commit("viewaction/removeView", this.viewtag);
    this.timer = null;
    let _this: any = this;
    if (_this.serviceStateEvent) {
      _this.serviceStateEvent.unsubscribe();
    }
    if (_this.portletStateEvent) {
      _this.portletStateEvent.unsubscribe();
    }
    if (_this.engine) {
      _this.engine.destroy();
    }
    // BUG fix: ”pagelink“ 再次推出登录后事件还在的问题修复
    window.removeEventListener("message", this.messageEvent);
  }

  public handleMessage() {
    window.addEventListener("message", this.messageEvent);
  }
// 服务商软电话修改个人信息
  public async postMesToServicePhone(obj:any){
    try {
      const post1=await this.$http.post('/api/v1/config/openapi/token/getToken',{account:'jmcw',pwd:md5('1qaz@WSX')},true)
      if(post1.data?.code!=0) return this.$message.warning(post1.data.msg)
      let data={
        abbreviate:'jmcw',
        companyId:508,
        operatorId:this.serviceName,
        password:md5(obj.newPassWord)
      }
      // @ts-ignore
      const post2=await axios.post('/api/v1/config/openapi/agent/editPwd',data,{headers:{token:post1.data.data.token}})
      if(post2.data?.code!=0) return this.$message.warning(post2.data.msg)
      // @ts-ignore
      const comp=this.$refs.phoneChangePw
      // @ts-ignore
      comp.modalVisible=false
      this.$message.success('密码已修改，请重新登录！')
      const iframe: any = this.$refs.serviceCallIframe
      iframe.contentWindow.postMessage({type:'cssToServiceCall',cssworkData:{type:'updateUserInfo'}}, '*');
    } catch (e:any) {
      this.$message.warning('服务商电话条系统错误！')
    }
  }
  public messageEvent(e: any) {
    const woIframe: any = this.$refs.woIframe
    // css触发服务商话务条登录、外拨功能
    if (e.data && (e.data.type === "cssToServiceCall")) {
      const iframe: any = this.$refs.serviceCallIframe
      iframe.contentWindow.postMessage(e.data, '*');
    }
    //服务商电话条触发css登录、登出功能
    if (e.data && (e.data.type === "ServiceCallToCss")) {
      let ServiceCallData=e.data.ServiceCallData
      if(ServiceCallData.type=='zuoxiStatus'){
        let arr=['请先登录软电话。','当前账号状态为通话中或其它不允许呼出的状态，请先检查软电话状态。']
        if(ServiceCallData.zuoxiStatus!=0) return this.$message.warning(arr[ServiceCallData.zuoxiStatus-1])
        woIframe.contentWindow.postMessage({type:'portalToCss',portalData:{type:'zuoxiStatus',...ServiceCallData}}, '*');
      }
      if(ServiceCallData.type=='login'){
        this.loginServiceCallVisible=true
      }
      if(ServiceCallData.type=='updateUserInfo'){
        if(location.origin!='https://css.jomoo.cn' && location.origin!='https://css.jomoo.com') return this.$message.warning('测试环境不支持修改个人信息！')
        // @ts-ignore
          const comp=this.$refs.phoneChangePw
          // @ts-ignore
          comp.modalVisible=true
      }
      if(ServiceCallData.type=='logout'){
        this.$confirm('确认退出服务商软电话？', '提示', {
            type: "warning"
        }).then(() => {
            const iframe: any = this.$refs.serviceCallIframe
            iframe.contentWindow.postMessage({type:'cssToServiceCall',cssworkData:{type:'logoutServicePhone'}}, '*');
        });
      }
      if(ServiceCallData.type=='bohao'){
        this.bohaopanVisible=true
      }
    }
    // 子系统触发400话务条外拨功能
    if (e.data && e.data.type === "isMakeCall") {
      this.$softPhone.jsDialCall(e.data.phone);
    }
    // 子系统token失效时
    if (e.data && Object.keys(e.data).includes("token") && !e.data.login) {
      this.$router.push({ name: "login" });
    }
    // 从子系统触发路由的接收
    if (e.data && e.data.type === "singleRoute") {
      this.isFromSubSystem = true;
      // const subPathList: any = e.data.data.allPathList
      const route: any = JSON.parse(e.data.data.current);
      const curPathList = this.$store.state.historyPathList;
      // const isAddPath: any = subPathList.filter((path: any) => {
      //   const portalPath: any = this.addPathRegExp(path)
      //   return !curPathList.includes(portalPath)
      // }).length > 0
      const isAddPath: any = curPathList.includes(route.fullPath);
      if (!isAddPath) {
        this.toggleIframe(route.fullPath);
        return false;
      }
      // 新增 - 跳转url
      this.addSubSystemPage(route);
    }
    // 子系统token失效
    if (e.data && e.data.type === "missToken") {
      this.$router.push({ name: "login" });
    }
    // 从一个子系统经过portal跳转到另一个子系统
    if (e.data && e.data.type === "pageLink") {
      const route: any = JSON.parse(e.data.route);
      this.addSubSystemPage(route);
    }

    if (e.data && e.data.type === "removeTagPage") {
      const route: any = JSON.parse(e.data.route);
      const portalPath: any = this.addPathRegExp(route.fullPath);
      this.$store.commit("deletePage", portalPath);
      this.goToPage();
    }
    // 改变弹框大小状态
    if (e.data && e.data.type === "changeDialogStatus") {
      this.centerDialogShowStatus = e.data.status;
    }
  }

  public goToPage() {
    const length = this.$store.state.historyPathList.length;
    if (length > 0) {
      const path = this.$store.state.historyPathList[length - 1];
      if (Object.is(path, this.$route.fullPath)) {
        return;
      }
      const index = this.$store.state.pageTagList.findIndex((page: any) =>
        Object.is(page.fullPath, path)
      );
      if (index >= 0) {
        const page = this.$store.state.pageTagList[index];
        this.$router.push({
          path: page.path,
          params: page.params,
          query: page.query,
        });
        const emitParams: any = {
          pushTo: page.fullPath,
          removedUrlList: [],
        };
        this.pagePath(emitParams);
      }
    } else {
      this.$router.push("/");
      const emitParams: any = {
        pushTo: "/",
        removedUrlList: [],
      };
      this.pagePath(emitParams);
    }
  }

  public addSubSystemPage(route: any) {
    route.fullPath = this.addPathRegExp(route.fullPath);
    route.path = this.addPathRegExp(route.path);
    // route.params = Object.assign({}, {
    //   appindexview: 'null'
    // }, route.params)
    const tabIndex: any = this.$store.state.historyPathList.indexOf(
      route.fullPath
    );
    if (tabIndex === -1) {
      this.$store.commit("addPage", route);
    }
    this.$router.push(route.fullPath);
    // update iframe url
    const subPath: any = this.replaceRegExp(route.fullPath);
    this.toggleIframe(subPath);
  }
  /**
   * 初始化传递token
   */
  public tokenPost(path: any) {
    const subPath: any = this.replaceRegExp(path);
    this.toggleIframe(subPath);
    const stateData: any = this.$router.app.$store.state["authresource"];
    const payload: any = {
      unires: stateData.resourceData,
      appmenu: stateData.menuData,
      enablepermissionvalid: stateData.enablePermissionValid,
    };
    // TODO: 格式优化
    this.timer = setTimeout(() => {
      this.urlPrefix.forEach((prefix: any, idx: any) => {
        const dataToken: any = {
          token: sessionStorage.getItem("token"),
          user: localStorage.getItem("user"),
          loginname: Util.getCookie("loginname"),
          parentIframe: window.location.origin,
          authData: JSON.stringify(payload),
        };
        // TODO: 使用公共方法报错
        let iframeInner: any = this.$refs[this.refArr[idx]];
        // iframeInner.onload = function() {
        //   let redirectUrl: any = getSysUrl(prefix)
        //   let url: any = redirectUrl.replace("/#", "/");
        //   iframeInner.contentWindow.postMessage(dataToken, url)
        // }
        iframeInner.onload = this.onloadIframe(iframeInner, prefix, dataToken);
      });
    }, 0);
  }

  public onloadIframe(iframeInner: any, prefix: any, dataToken: any) {
    let redirectUrl: any = getSysUrl(prefix);
    let url: any = redirectUrl.replace("/#", "/");
    iframeInner.contentWindow.postMessage(dataToken, url);
  }
  /**
   * 切换tab触发
   */
  public pagePath(pathObj: any) {
    const subPath: any = this.replaceRegExp(pathObj.pushTo);
    // const removeUrl: any = this.replaceRegExp(pathObj?.removedUrlList[0])
    this.activePath = subPath;
    const allPathList: any = this.$store.state.historyPathList
      .filter((item: any) => item)
      .map((item: any) => this.replaceRegExp(item));
    this.toggleIframe(subPath);
    if (pathObj.removedUrlList.length <= 0) {
      this.toggleOutside();
      return;
    }
    let splitSysArr = new Array(5).fill("");
    allPathList.forEach((path: any) => {
      const index: any = this.getMatchedSys(path);
      splitSysArr[index] = splitSysArr[index] || [];
      splitSysArr[index].push(path);
    });
    splitSysArr.forEach((item: any, idx: any) => {
      const sameIdx: any = this.getMatchedSys(subPath);
      const tabShowList: any = item || []; // 父页面剩余展示的tab
      const sys: any = this.urlPrefix[idx];
      const pushTo: any =
        sameIdx == idx
          ? subPath
          : tabShowList.length
          ? tabShowList[0]
          : getSysUrl(sys);
      const data: any = {
        type: "batchRemove",
        sys: sys, // 跳转到某个子系统
        data: {
          pushTo: pushTo,
          tabShowList: tabShowList,
        },
      };
      !this.isFromSubSystem &&
        postMessageToIframe(data, sys, this.$refs[this.refArr[idx]]);
    });
  }

  public toggleIframe(path: any, isActive: boolean = true) {
    // portal 的路由
    const isPortal = this.portalRoute.some((value: string) => value == path);
    if (isPortal) {
      this.$router.push(path);
      return;
    }

    // 忽略跳转到根路径的path
    const isRootPath: any =
      this.urlPrefix.filter((itemPath: any) => {
        const slash: any = !itemPath.includes("/") ? "/" : "";
        return slash + itemPath === path;
      }).length > 0;
    let redirectUrl: any = getSysUrl(path);
    const finalPath: any = isRootPath ? redirectUrl : redirectUrl + path;
    let activePath: any = this.$route.fullPath;
    if (isRootPath) {
      const length = this.$store.state.historyPathList.length;
      if (length > 0) {
        const path = this.$store.state.historyPathList[length - 1];
        if (Object.is(path, this.$route.fullPath)) {
          return;
        }
        activePath = path;
        this.$router.push(path);
      } else {
        activePath = "";
        this.$router.push("/");
      }
    } else {
      activePath = this.addPathRegExp(path);
      this.$router.push(this.addPathRegExp(path));
    }
    const prevIdx: any = this.getMatchedSys(finalPath);
    const _this: any = this;
    _this.$set(_this, _this.refArr[prevIdx] + "Url", finalPath);
    const idx: any = _this.getMatchedSys(activePath);
    _this.showArr = _this.showArr.map((item: any, index: any) => idx === index);
    _this.showArr = [..._this.showArr];
    if (idx < 0) {
      // 重置iframe的src
      _this.urlPrefix.forEach((prefix: any, index: any) => {
        let frame: any = _this.refArr[index];
        if (frame.contentWindow) {
          frame.contentWindow.document.write(""); //清空iframe的内容
          frame.contentWindow.close(); //避免iframe内存泄漏
          frame.remove(); //删除iframe
        }
        (_this as any)[_this.refArr[index] + "Url"] = "about:blank";
      });
    } else {
      // 当前激活路由不属于的子系统，修改url为已存在的理由
      _this.urlPrefix.forEach((prefix: any, index: any) => {
        if (index !== idx) {
          const sysUrlList: any = this.getAllUrlBySubSys(prefix);
          let hideUrl: any = "about:blank";
          if (sysUrlList.length) {
            const redirectUrl: any = getSysUrl(sysUrlList[0]);
            let subPath: any = this.replaceRegExp(sysUrlList[0]);
            subPath = subPath[0] === "/" ? subPath : "/" + subPath;
            hideUrl = `${redirectUrl}${subPath}`;
          }
          (_this as any)[_this.refArr[index] + "Url"] = hideUrl;
        }
      });
    }
    // 判断是那个iframe中删除tab,如果是最后一个,则需要重置iframe
    let m = this.getEveryIframeTabCount();
    // 如果某个iframe不再有tab页,则重置url
    _this.urlPrefix.forEach((prefix: any, index: any) => {
      if (!m.has(index)) {
        let frame: any = _this.refArr[index];
        if (frame.contentWindow) {
          frame.contentWindow.document.write(""); //清空iframe的内容
          frame.contentWindow.close(); //避免iframe内存泄漏
          frame.remove(); //删除iframe
        }
        (_this as any)[_this.refArr[index] + "Url"] = "about:blank";
      }
    });
    // if (_this.isRefresh && idx >= 0) {
    //   const inIframe: any = _this.$refs[_this.refArr[idx]]
    //   inIframe.contentWindow && inIframe.contentWindow.location.reload()
    // }
    this.isFromSubSystem = false;
  }

  public getMatchedSys(path: string) {
    const matchIdx: any = this.urlPrefix.findIndex((prefix: any) =>
      path.includes(prefix)
    );
    return matchIdx;
  }

  public getEveryIframeTabCount() {
    let m = new Map();
    this.$store.getters.getHistoryPathList().forEach((url: any, index: any) => {
      const idx = this.getMatchedSys(url);
      let count = m.get(idx);
      if (m.has(idx)) {
        m.set(idx, count + 1);
      } else {
        m.set(idx, 1);
      }
    });
    return m;
  }

  public getAllUrlBySubSys(subsys: any) {
    if (subsys) {
      return this.$store.state.historyPathList.filter((path: any) => {
        return path.includes(subsys);
      });
    }
    return [];
  }


  /**
   * 执行mounted后的逻辑
   *
   * @memberof AppIndexViewBase
   */
  public afterMounted() {
    const _this: any = this;
    _this.engineInit();
    if (_this.loadModel && _this.loadModel instanceof Function) {
      _this.loadModel();
    }
    this.viewState.next({ tag: "appmenu", action: "load", data: {} });
    this.$viewTool.setIndexParameters([
      { pathName: "appindexview", parameterName: "appindexview" },
    ]);
    this.$viewTool.setIndexViewParam(this.context);
    this.mouse_move();
  }

  /**
   * 关闭视图
   *
   * @param {any[]} args
   * @memberof AppIndexViewBase
   */
  public closeView(args: any[]): void {
    let _view: any = this;
    if (_view.viewdata) {
      _view.$emit("viewdataschange", Array.isArray(args) ? args : [args]);
      _view.$emit("close", Array.isArray(args) ? args : [args]);
    } else if (_view.$tabPageExp) {
      _view.$tabPageExp.onClose(_view.$route.fullPath);
    }
  }

  /**
   * 菜单位置
   *
   * @public
   * @type {string}
   * @memberof AppIndexViewBase
   */
  public mode: string = "vertical";

  /**
   * 导航模式(route:面包屑模式、tab:分页导航模式)
   *
   * @type {string}
   * @memberof AppIndexViewBase
   */
  @Provide()
  public navModel: string = "tab";

  /**
   * 抽屉状态
   *
   * @type {boolean}
   * @memberof AppIndexViewBase
   */
  public contextMenuDragVisiable: boolean = false;

  /**
   * 是否支持应用切换
   *
   * @type {boolean}
   * @memberof AppIndexViewBase
   */
  public isEnableAppSwitch: boolean = false;

  /**
   * 初始化之前
   *
   * @memberof AppIndexViewBase
   */
  public beforeCreate() {
    let navDataService = NavDataService.getInstance();
    navDataService.removeAllNavData();
  }

  /**
   * 当前主题
   *
   * @readonly
   * @memberof AppIndexViewBase
   */
  get selectTheme() {
    if (this.$router.app.$store.state.selectTheme) {
      return this.$router.app.$store.state.selectTheme;
    } else if (localStorage.getItem("theme-class")) {
      return localStorage.getItem("theme-class");
    } else {
      return appConfig.defaultTheme;
    }
  }

  /**
   * 当前字体
   *
   * @readonly
   * @memberof AppIndexViewBase
   */
  get selectFont() {
    if (this.$router.app.$store.state.selectFont) {
      return this.$router.app.$store.state.selectFont;
    } else if (localStorage.getItem("font-family")) {
      return localStorage.getItem("font-family");
    } else {
      return appConfig.defaultFont;
    }
  }

  /**
   * 菜单收缩变化
   *
   * @type {boolean}
   * @memberof AppIndexViewBase
   */
  public collapseChange: boolean = false;

  /**
   * 菜单收缩点击
   *
   * @memberof AppIndexViewBase
   */
  public handleClick(): void {
    this.collapseChange = !this.collapseChange;
    const tempThis = this as any;
    if (tempThis.$bus) {
      tempThis.$bus.$emit("collapseChange");
    }
  }

  /**
   * 默认打开的视图
   *
   * @type {*}
   * @memberof AppIndexViewBase
   */
  public defPSAppView: any = {};

  /**
   * 应用起始页面
   *
   * @type {boolean}
   * @memberof AppIndexViewBase
   */
  public isDefaultPage: boolean = true;

  /**
   * 空白视图模式
   *
   * @type {boolean}
   * @memberof AppIndexViewBase
   */
  public isBlankMode: boolean = false;

  /**
   * 获取样式
   *
   * @readonly
   * @type {string[]}
   * @memberof AppIndexViewBase
   */
  get themeClasses(): string {
    return this.selectTheme;
  }

  /**
   * 是否显示顶部工具条
   */
  public showToolBar = true;

  /**
   * 主题字体
   *
   * @readonly
   * @type {*}
   * @memberof AppIndexViewBase
   */
  get themeStyle(): any {
    return {
      height: (this.showToolBar || this.isService) ? "calc(100vh - 55px)" : "100vh",
      "font-family": this.selectFont,
      overflow: "hidden",
    };
  }

  /**
   * 是否是热线客户专员
   */
  isHotLineSpec() {
    const usr: any = localStorage.getItem("user");
    const extrole: any = usr ? JSON.parse(usr).sessionParams.extrole || [] : [];
    this.showToolBar = extrole.includes("HOTLINE_CUSTOMER_SERVICE_SPECIALIST");
  }
  /**
   * 获取路由列表
   *
   * @readonly
   * @type {any[]}
   * @memberof AppIndexViewBase
   */
  get getRouterList(): any[] {
    return this.$store.state.historyPathList;
  }

  /**
   * 获取路由键值
   *
   * @readonly
   * @type {string}
   * @memberof AppIndexViewBase
   */
  get getRouterViewKey(): string {
    return this.getMatchedSys(this.$route.fullPath) === -1
      ? this.$route.fullPath
      : "";
  }

  /**
   * 标题点击事件
   */
  public handleTitleClick() {}

  /**
   * 鼠标拖动事件
   *
   * @param {*} val
   * @returns {*}
   * @memberof AppIndexViewBase
   */
  public mouse_move() {
    let move_axis: any = document.getElementById("move_axis");
    let left_move: any = document.getElementById("left_move");
    let right_move: any = document.getElementById("right_move");
    let movebox: any = document.getElementById("movebox");
    let leftWidth: number = parseInt(left_move.style.width);
    move_axis.onmousedown = (e: any) => {
      let startX = e.clientX;
      move_axis.left = move_axis.offsetLeft;
      document.onmousemove = (e: any) => {
        let endX = e.clientX;
        let moveLen = move_axis.left + (endX - startX);
        let maxT = movebox.clientWidth - move_axis.offsetWidth;
        if (moveLen < 150) moveLen = 150;
        if (moveLen > maxT - 150) moveLen = maxT - 150;
        move_axis.style.left = moveLen;
        left_move.style.width = moveLen + "px";
        right_move.style.width = movebox.clientWidth - moveLen - 5 + "px";
        if (moveLen > 500) {
          left_move.style.width = 500 + "px";
        }

        let left_width: number = parseInt(left_move.style.width);
        move_axis.style.left = left_width - 5 + "px";
        if (left_width < leftWidth) {
          move_axis.style.left = leftWidth - 5 + "px";
        }
      };
      document.onmouseup = (evt) => {
        document.onmousemove = null;
        document.onmouseup = null;
        move_axis.releaseCapture && move_axis.releaseCapture();
      };
      move_axis.setCapture && move_axis.setCapture();
      return false;
    };
  }

  public replaceRegExp(path: string) {
    return path ? path.replace(/\/appindexview(\/null)?/, "") : "";
  }

  public addPathRegExp(path: string) {
    const strPath = path || "";
    return strPath.includes("/appindexview")
      ? strPath
      : `/appindexview/null${strPath}`;
  }

  public bodyClick() {
    this.toggleOutside();
  }

  public toggleOutside() {
    // 切换tab，隐藏dropdown等
    this.urlPrefix.forEach((prefix: any, idx: any) => {
      const data: any = {
        type: "mouseup",
        sys: this.urlPrefix[idx], // 跳转到某个子系统
        data: "",
      };
      postMessageToIframe(
        data,
        this.urlPrefix[idx],
        this.$refs[this.refArr[idx]]
      );
    });
  }

  // 获取用户类型 1是集团账户 2是服务商用户
  public getUserType() {
    const userStr: string = localStorage.getItem("user") || "";
    const user = JSON.parse(userStr);
    return user?.sessionParams?.extusertype;
  }

  public aiurl: any = "";

  // 根据放大或缩小，控制智能辅助的展开收缩
  handleDialog() {
    let userId: any = null;
    if (localStorage.getItem("user")) {
      let user: any = JSON.parse(localStorage.getItem("user") as string);
      if (user && user.userId) {
        userId = user.userId;
      }
    }
    this.aiurl = "frontend/onlyview.html?agent=" + userId;
    if (this.iframeVisible == false) {
      let pssoIframe: any = document.getElementById("pssoIframe");
      pssoIframe.setAttribute("src", this.aiurl);
    }

    this.centerDialogVisible = !this.centerDialogVisible;
    this.iframeVisible = true;
  }

  public closeDialog() {
    this.iframeVisible = false;
    this.centerDialogVisible = false;
    let pssoIframe: any = document.getElementById("pssoIframe");
      pssoIframe.setAttribute("src", null);
  }
}
